(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["educatodo-abc-domino"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffle = (items) => { const copy=[...items]; for(let i=copy.length-1;i>0;i-=1){const j=Math.floor(Math.random()*(i+1));[copy[i],copy[j]]=[copy[j],copy[i]];} return copy; };
    const escapeHtml = (value) => String(value).replace(/[&<>"]/g,(character)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[character]));
    const init = (root) => {
      if (!root || root.dataset.eadReady === 'true') return;
      root.dataset.eadReady='true';
      const items=JSON.parse(root.querySelector('[data-ead-items]').textContent);
      const backgrounds=['#fff0ad','#dff4ff','#eee8ff','#e5f5d6','#ffe5dc','#dff5ef'];
      const state={player:null,active:null,heard:new Set(),query:'',quiz:[],round:0,score:0,answer:null,wrong:null,options:null,error:null};
      const grid=root.querySelector('[data-ead-grid]'); const game=root.querySelector('[data-ead-game]'); const feature=root.querySelector('[data-ead-feature]'); const score=root.querySelector('[data-ead-score]');
      const renderProgress=()=>{root.querySelector('[data-ead-progress-label]').textContent=`${state.heard.size}/26`;root.querySelector('[data-ead-progress-bar]').style.width=`${state.heard.size/26*100}%`;};
      const renderGrid=()=>{
        const query=state.query.trim().toLocaleLowerCase('es');
        const filtered=items.filter((item)=>!query||item.en.toLocaleLowerCase('en').includes(query)||item.es.toLocaleLowerCase('es').includes(query)||item.letter.toLowerCase()===query);
        root.querySelector('[data-ead-count]').textContent=`${filtered.length} ${filtered.length===1?'tarjeta':'tarjetas'}`;
        grid.innerHTML=filtered.length?filtered.map((item)=>{const index=items.indexOf(item);return `<button type="button" class="ead-card${state.active===item.slug?' is-playing':''}" style="--card-bg:${backgrounds[index%backgrounds.length]}" data-ead-slug="${item.slug}" aria-label="Escuchar ${item.en}"><span class="ead-card-visual"><span class="ead-letter">${item.letter}</span>${state.heard.has(item.slug)?'<span class="ead-check">✓</span>':''}<span class="ead-emoji">${item.emoji}</span><span class="ead-play">▶</span></span><span class="ead-copy"><b>${item.en}</b><small>${item.es}</small></span></button>`;}).join(''):'<div class="ead-empty"><div style="font-size:48px">🔎</div><h3>No encontramos esa palabra</h3><p>Prueba otra búsqueda.</p></div>';
      };
      const play=(item)=>{
        if(state.player)state.player.pause(); const audio=new Audio(item.audio); state.player=audio;state.active=item.slug;state.error=null;
        audio.addEventListener('ended',()=>{state.active=null;renderGrid();},{once:true});
        audio.addEventListener('error',()=>{state.active=null;state.error=item.slug;renderGrid();renderGame();},{once:true});
        audio.play().then(()=>{state.heard.add(item.slug);renderProgress();renderGrid();}).catch(()=>{state.active=null;state.error=item.slug;renderGrid();renderGame();});
      };
      const showFeature=(item)=>{feature.hidden=false;feature.innerHTML=`<div class="ead-feature-inner"><div class="ead-feature-word"><span class="ead-feature-emoji">${item.emoji}</span><div><small>${item.letter} is for…</small><h3>${item.en} <span>/ ${item.es}</span></h3></div></div><button type="button" data-ead-feature-play="${item.slug}">🔊 Escuchar otra vez</button></div>`;play(item);};
      const renderScore=()=>{score.hidden=!state.quiz.length;score.innerHTML=`Reto <span>${Math.min(state.round+1,10)}/10</span> · Aciertos <span>${state.score}</span>`;};
      const startQuiz=()=>{state.quiz=shuffle(items).slice(0,10);state.round=0;state.score=0;state.answer=null;state.wrong=null;state.options=null;state.error=null;renderGame();play(state.quiz[0]);};
      const renderGame=()=>{
        renderScore();
        if(!state.quiz.length){game.innerHTML='<div class="ead-welcome"><div><span class="ead-welcome-icon">🎧</span><h3>¿Reconoces la palabra?</h3><p>Escucha en inglés y elige la asociación correcta entre cuatro opciones.</p><button type="button" class="ead-primary" data-ead-start>Comenzar 10 retos</button></div></div>';return;}
        if(state.round>=10){game.innerHTML=`<div class="ead-result"><div><div style="font-size:70px">🏆</div><h3>${state.score}/10</h3><p>${state.score>=8?'¡Excelente! Tu vocabulario A–Z está creciendo.':'¡Buen intento! Explora las tarjetas y vuelve a jugar.'}</p><button type="button" class="ead-primary" data-ead-start>Jugar otra vez</button></div></div>`;return;}
        const target=state.quiz[state.round];if(!state.options)state.options=shuffle([target,...shuffle(items.filter((item)=>item.slug!==target.slug)).slice(0,3)]);
        game.innerHTML=`<div class="ead-challenge"><div class="ead-listen"><div><small>Reto ${state.round+1} de 10</small><h3>Escucha la palabra en inglés</h3></div><button type="button" data-ead-replay>🔊 Repetir sonido</button></div>${state.error===target.slug?'<p class="ead-error">No pudimos reproducir este audio. Intenta nuevamente.</p>':''}<div class="ead-choices">${state.options.map((item)=>`<button type="button" class="ead-choice${state.answer===item.slug?' is-correct':''}${state.wrong===item.slug?' is-wrong':''}" data-ead-choice="${item.slug}" ${state.answer?'disabled':''}><span class="ead-choice-emoji">${item.emoji}</span><b>${item.en}</b><small>${item.es}</small></button>`).join('')}</div><div class="ead-feedback">${state.answer?`<div class="good"><span>✓ ¡Correcto! ${target.en} significa ${target.es}.</span><button type="button" data-ead-next>${state.round===9?'Ver resultado':'Siguiente reto'} →</button></div>`:state.wrong?'<div class="try"><span>Escucha otra vez e inténtalo de nuevo.</span></div>':''}</div></div>`;
      };
      root.addEventListener('click',(event)=>{
        const card=event.target.closest('[data-ead-slug]');if(card){showFeature(items.find((item)=>item.slug===card.dataset.eadSlug));return;}
        const replayFeature=event.target.closest('[data-ead-feature-play]');if(replayFeature){play(items.find((item)=>item.slug===replayFeature.dataset.eadFeaturePlay));return;}
        if(event.target.closest('[data-ead-random]')){showFeature(items[Math.floor(Math.random()*items.length)]);return;}
        if(event.target.closest('[data-ead-start]')){startQuiz();return;}
        if(event.target.closest('[data-ead-replay]')){play(state.quiz[state.round]);return;}
        const choice=event.target.closest('[data-ead-choice]');if(choice&&!state.answer){const target=state.quiz[state.round];if(choice.dataset.eadChoice===target.slug){state.answer=target.slug;state.score+=1;}else state.wrong=choice.dataset.eadChoice;renderGame();return;}
        if(event.target.closest('[data-ead-next]')){state.round+=1;state.answer=null;state.wrong=null;state.options=null;state.error=null;renderGame();if(state.round<10)play(state.quiz[state.round]);}
      });
      root.querySelector('[data-ead-search]').addEventListener('input',(event)=>{state.query=event.target.value;renderGrid();});
      renderGrid();renderProgress();renderGame();
    };
    const initializeAll=()=>document.querySelectorAll('[data-ead-root]').forEach(init);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeAll);else initializeAll();
    document.addEventListener('shopify:section:load',(event)=>init(event.target.querySelector('[data-ead-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-abecedario-ingles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffle = (items) => {
      const copy = [...items];
      for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    };

    const init = (root) => {
      if (!root || root.dataset.eabcReady === 'true') return;
      root.dataset.eabcReady = 'true';
      const items = JSON.parse(root.querySelector('[data-eabc-items]').textContent);
      const colors = ['#f4513b','#4d65c8','#15959a','#ef8f22','#9b55b7','#3c9b57'];
      const state = { player:null, active:null, heard:new Set(), sequence:false, sequenceIndex:0, quiz:[], round:0, score:0, answer:null, wrong:null, error:null };
      const grid = root.querySelector('[data-eabc-grid]');
      const game = root.querySelector('[data-eabc-game]');
      const score = root.querySelector('[data-eabc-score]');
      const now = root.querySelector('[data-eabc-now]');
      const sequenceButton = root.querySelector('[data-eabc-sequence]');

      const renderProgress = () => {
        root.querySelector('[data-eabc-progress-label]').textContent = `${state.heard.size}/26`;
        root.querySelector('[data-eabc-progress-bar]').style.width = `${state.heard.size / 26 * 100}%`;
      };

      const stop = () => {
        state.sequence = false;
        sequenceButton.textContent = '▶ Escuchar A–Z';
        if (state.player) state.player.pause();
        state.player = null;
        state.active = null;
        now.hidden = true;
      };

      const play = (item, onEnded) => {
        if (state.player) state.player.pause();
        const audio = new Audio(item.audio);
        state.player = audio;
        state.active = item.letter;
        state.error = null;
        now.hidden = false;
        now.innerHTML = `<div class="eabc-now-inner"><span class="eabc-now-letter">${item.letter}</span><div><small>Escuchando</small><b>Letra ${item.letter}</b></div></div>`;
        const finish = () => {
          state.active = null;
          renderGrid();
          if (onEnded) onEnded();
        };
        audio.addEventListener('ended', finish, { once:true });
        audio.addEventListener('error', () => { state.error = item.letter; state.sequence = false; sequenceButton.textContent = '▶ Escuchar A–Z'; finish(); renderGame(); }, { once:true });
        audio.play().then(() => {
          state.heard.add(item.letter);
          renderProgress();
          renderGrid();
        }).catch(() => { state.error = item.letter; finish(); renderGame(); });
      };

      const renderGrid = () => {
        grid.innerHTML = items.map((item, index) => `<button type="button" class="eabc-card${state.active === item.letter ? ' is-playing' : ''}${state.heard.has(item.letter) ? ' is-heard' : ''}" style="--card-color:${colors[index % colors.length]}" data-eabc-letter="${item.letter}" aria-label="Escuchar la letra ${item.letter}"><span class="eabc-card-letter">${item.letter}</span><small>Escuchar</small><i>▶</i></button>`).join('');
      };

      const renderScore = () => {
        score.hidden = state.quiz.length === 0;
        score.innerHTML = `Reto <span>${Math.min(state.round + 1, 10)}/10</span> · Aciertos <span>${state.score}</span>`;
      };

      const startQuiz = () => {
        stop();
        state.quiz = shuffle(items).slice(0,10);
        state.round = 0; state.score = 0; state.answer = null; state.wrong = null; state.error = null;
        renderGame();
        play(state.quiz[0]);
      };

      const renderGame = () => {
        renderScore();
        if (!state.quiz.length) {
          game.innerHTML = '<div class="eabc-welcome"><div><span class="eabc-welcome-icon">🎧</span><h3>Entrena tu oído</h3><p>Escucha una letra y elige la respuesta correcta entre cuatro opciones.</p><button type="button" class="eabc-primary" data-eabc-start>Comenzar 10 retos</button></div></div>';
          return;
        }
        if (state.round >= 10) {
          game.innerHTML = `<div class="eabc-result"><div><div style="font-size:70px">🏆</div><h3>${state.score}/10</h3><p>${state.score >= 8 ? '¡Excelente oído! Dominas muy bien las letras.' : '¡Buen trabajo! Recorre las tarjetas y vuelve a intentarlo.'}</p><button type="button" class="eabc-primary" data-eabc-start>Jugar otra vez</button></div></div>`;
          return;
        }
        const target = state.quiz[state.round];
        const distractors = shuffle(items.filter((item) => item.letter !== target.letter)).slice(0,3);
        if (!state.answer && !state.options) state.options = shuffle([target,...distractors]);
        const options = state.options || shuffle([target,...distractors]);
        state.options = options;
        game.innerHTML = `<div class="eabc-challenge"><div class="eabc-listen"><div><small>Reto ${state.round + 1} de 10</small><h3>Escucha con atención</h3></div><button type="button" data-eabc-replay>🔊 Repetir sonido</button></div>${state.error === target.letter ? '<p class="eabc-error">No pudimos reproducir este audio. Intenta nuevamente.</p>' : ''}<div class="eabc-choices">${options.map((item) => `<button type="button" class="eabc-choice${state.answer === item.letter ? ' is-correct' : ''}${state.wrong === item.letter ? ' is-wrong' : ''}" data-eabc-choice="${item.letter}" ${state.answer ? 'disabled' : ''}>${item.letter}</button>`).join('')}</div><div class="eabc-feedback">${state.answer ? `<div class="good"><span>✓ ¡Correcto! Escuchaste la letra ${target.letter}.</span><button type="button" data-eabc-next>${state.round === 9 ? 'Ver resultado' : 'Siguiente reto'} →</button></div>` : state.wrong ? '<div class="try"><span>Escucha otra vez e inténtalo de nuevo.</span></div>' : ''}</div></div>`;
      };

      root.addEventListener('click', (event) => {
        const letterButton = event.target.closest('[data-eabc-letter]');
        if (letterButton) {
          state.sequence = false; sequenceButton.textContent = '▶ Escuchar A–Z';
          play(items.find((item) => item.letter === letterButton.dataset.eabcLetter));
          return;
        }
        if (event.target.closest('[data-eabc-sequence]')) {
          if (state.sequence) { stop(); return; }
          state.sequence = true; state.sequenceIndex = 0; sequenceButton.textContent = '■ Detener';
          const next = () => {
            if (!state.sequence) return;
            if (state.sequenceIndex >= items.length) { stop(); return; }
            const item = items[state.sequenceIndex++];
            play(item, () => { if (state.sequence) next(); });
          };
          next();
          return;
        }
        if (event.target.closest('[data-eabc-start]')) { state.options = null; startQuiz(); return; }
        if (event.target.closest('[data-eabc-replay]')) { play(state.quiz[state.round]); return; }
        const choice = event.target.closest('[data-eabc-choice]');
        if (choice && !state.answer) {
          const target = state.quiz[state.round];
          if (choice.dataset.eabcChoice === target.letter) { state.answer = target.letter; state.score += 1; }
          else { state.wrong = choice.dataset.eabcChoice; }
          renderGame();
          return;
        }
        if (event.target.closest('[data-eabc-next]')) {
          state.round += 1; state.answer = null; state.wrong = null; state.error = null; state.options = null;
          renderGame();
          if (state.round < 10) play(state.quiz[state.round]);
        }
      });

      renderGrid(); renderProgress(); renderGame();
    };

    const initializeAll = () => document.querySelectorAll('[data-eabc-root]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-eabc-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-bingo-sonidos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffle=(items)=>{const copy=[...items];for(let i=copy.length-1;i>0;i-=1){const j=Math.floor(Math.random()*(i+1));[copy[i],copy[j]]=[copy[j],copy[i]];}return copy;};
    const init=(root)=>{
      if(!root||root.dataset.ebsReady==='true')return;root.dataset.ebsReady='true';
      const items=JSON.parse(root.querySelector('[data-ebs-items]').textContent);const bySlug=new Map(items.map((item)=>[item.slug,item]));
      const catColors={Animales:'#eee8ff',Hogar:'#fff0ad',Transportes:'#e4f4d4',Personas:'#ffe5dc',Naturaleza:'#dff4ff',Objetos:'#e1f5ef'};
      const state={player:null,active:null,heard:new Set(),query:'',category:'Todos',quiz:[],round:0,score:0,answer:null,wrong:null,options:null,error:null};
      const grid=root.querySelector('[data-ebs-grid]');const game=root.querySelector('[data-ebs-game]');const feature=root.querySelector('[data-ebs-feature]');const score=root.querySelector('[data-ebs-score]');
      const renderProgress=()=>{root.querySelector('[data-ebs-progress-label]').textContent=`${state.heard.size}/64`;root.querySelector('[data-ebs-progress-bar]').style.width=`${state.heard.size/64*100}%`;};
      const renderGrid=()=>{const query=state.query.trim().toLocaleLowerCase('es');const filtered=items.filter((item)=>(state.category==='Todos'||item.cat===state.category)&&(!query||item.name.toLocaleLowerCase('es').includes(query)));root.querySelector('[data-ebs-count]').textContent=`${filtered.length} ${filtered.length===1?'sonido':'sonidos'}`;grid.innerHTML=filtered.length?filtered.map((item)=>{const index=items.indexOf(item);return `<button type="button" class="ebs-card${state.active===item.slug?' is-playing':''}" style="--card-bg:${catColors[item.cat]}" data-ebs-slug="${item.slug}" aria-label="Escuchar ${item.name}"><span class="ebs-card-visual"><span class="ebs-number">${String(index+1).padStart(2,'0')}</span>${state.heard.has(item.slug)?'<span class="ebs-check">✓</span>':''}<span class="ebs-emoji">${item.emoji}</span><span class="ebs-play">▶</span></span><span class="ebs-copy"><b>${item.name}</b><small>${item.cat}</small></span></button>`;}).join(''):'<div class="ebs-empty"><div style="font-size:48px">🔎</div><h3>No encontramos ese sonido</h3><p>Prueba otra búsqueda o categoría.</p></div>';};
      const play=(item)=>{if(state.player)state.player.pause();const audio=new Audio(item.audio);state.player=audio;state.active=item.slug;state.error=null;audio.addEventListener('ended',()=>{state.active=null;renderGrid();},{once:true});audio.addEventListener('error',()=>{state.active=null;state.error=item.slug;renderGrid();renderGame();},{once:true});audio.play().then(()=>{state.heard.add(item.slug);renderProgress();renderGrid();}).catch(()=>{state.active=null;state.error=item.slug;renderGrid();renderGame();});};
      const showFeature=(item)=>{feature.hidden=false;feature.innerHTML=`<div class="ebs-feature-inner"><div class="ebs-feature-word"><span class="ebs-feature-emoji">${item.emoji}</span><div><small>${item.cat}</small><h3>${item.name}</h3></div></div><button type="button" data-ebs-feature-play="${item.slug}">🔊 Escuchar otra vez</button></div>`;play(item);};
      const renderScore=()=>{score.hidden=!state.quiz.length;score.innerHTML=`Reto <span>${Math.min(state.round+1,10)}/10</span> · Aciertos <span>${state.score}</span>`;};
      const startQuiz=()=>{state.quiz=shuffle(items).slice(0,10);state.round=0;state.score=0;state.answer=null;state.wrong=null;state.options=null;state.error=null;renderGame();play(state.quiz[0]);};
      const renderGame=()=>{renderScore();if(!state.quiz.length){game.innerHTML='<div class="ebs-welcome"><div><span class="ebs-welcome-icon">🎧</span><h3>Activa tus oídos</h3><p>Escucha un efecto real y encuentra su fuente entre cuatro opciones.</p><button type="button" class="ebs-primary" data-ebs-start>Comenzar 10 retos</button></div></div>';return;}if(state.round>=10){game.innerHTML=`<div class="ebs-result"><div><div style="font-size:70px">🏆</div><h3>${state.score}/10</h3><p>${state.score>=8?'¡Excelente atención auditiva! Reconoces muy bien los sonidos.':'¡Buen trabajo! Explora la biblioteca y vuelve a intentarlo.'}</p><button type="button" class="ebs-primary" data-ebs-start>Jugar otra vez</button></div></div>`;return;}const target=state.quiz[state.round];if(!state.options)state.options=shuffle([target,...shuffle(items.filter((item)=>item.slug!==target.slug)).slice(0,3)]);game.innerHTML=`<div class="ebs-challenge"><div class="ebs-listen"><div><small>Reto ${state.round+1} de 10</small><h3>¿Qué produjo este sonido?</h3></div><button type="button" data-ebs-replay>🔊 Repetir sonido</button></div>${state.error===target.slug?'<p class="ebs-error">No pudimos reproducir este efecto. Intenta nuevamente.</p>':''}<div class="ebs-choices">${state.options.map((item)=>`<button type="button" class="ebs-choice${state.answer===item.slug?' is-correct':''}${state.wrong===item.slug?' is-wrong':''}" data-ebs-choice="${item.slug}" ${state.answer?'disabled':''}><span>${item.emoji}</span><b>${item.name}</b></button>`).join('')}</div><div class="ebs-feedback">${state.answer?`<div class="good"><span>✓ ¡Correcto! Era ${target.name}.</span><button type="button" data-ebs-next>${state.round===9?'Ver resultado':'Siguiente reto'} →</button></div>`:state.wrong?'<div class="try"><span>Escucha otra vez e inténtalo de nuevo.</span></div>':''}</div></div>`;};
      root.addEventListener('click',(event)=>{const card=event.target.closest('[data-ebs-slug]');if(card){showFeature(bySlug.get(card.dataset.ebsSlug));return;}const featurePlay=event.target.closest('[data-ebs-feature-play]');if(featurePlay){play(bySlug.get(featurePlay.dataset.ebsFeaturePlay));return;}if(event.target.closest('[data-ebs-random]')){showFeature(items[Math.floor(Math.random()*items.length)]);return;}const category=event.target.closest('[data-ebs-category]');if(category){state.category=category.dataset.ebsCategory;root.querySelectorAll('[data-ebs-category]').forEach((button)=>button.classList.toggle('is-active',button===category));renderGrid();return;}if(event.target.closest('[data-ebs-start]')){startQuiz();return;}if(event.target.closest('[data-ebs-replay]')){play(state.quiz[state.round]);return;}const choice=event.target.closest('[data-ebs-choice]');if(choice&&!state.answer){const target=state.quiz[state.round];if(choice.dataset.ebsChoice===target.slug){state.answer=target.slug;state.score+=1;}else state.wrong=choice.dataset.ebsChoice;renderGame();return;}if(event.target.closest('[data-ebs-next]')){state.round+=1;state.answer=null;state.wrong=null;state.options=null;state.error=null;renderGame();if(state.round<10)play(state.quiz[state.round]);}});
      root.querySelector('[data-ebs-search]').addEventListener('input',(event)=>{state.query=event.target.value;renderGrid();});
      renderGrid();renderProgress();renderGame();
    };
    const initializeAll=()=>document.querySelectorAll('[data-ebs-root]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeAll);else initializeAll();document.addEventListener('shopify:section:load',(event)=>init(event.target.querySelector('[data-ebs-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-catalogo"]) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-edu-catalog-share]').forEach((element) => {
        if (element.dataset.copyReady) return;
        const button = element.querySelector('[data-edu-catalog-copy]');
        const input = element.querySelector('[data-edu-catalog-link]');
        const status = element.querySelector('[data-edu-catalog-status]');
        if (!button || !input || !status) return;
        element.dataset.copyReady = 'true';
        button.hidden = false;
        button.addEventListener('click', async () => {
          try {
            if (!window.isSecureContext || !navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(input.value);
            status.textContent = 'Enlace copiado. Ya puedes pegarlo para compartir este catálogo.';
          } catch {
            input.focus();
            input.select();
            input.setSelectionRange(0, input.value.length);
            status.textContent = 'Enlace seleccionado. Usa la opción Copiar de tu dispositivo, Ctrl+C o ⌘C.';
          }
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-fabricante"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.edu-hero-buy__form')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    const card = form.closest('.edu-hero-buy');
    const button = form.querySelector('button[type="submit"]');
    const message = card.querySelector('[data-buy-message]');
    const cartLink = card.querySelector('[data-buy-cart-link]');
    const originalLabel = button.textContent;
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = card.dataset.pendingMessage;
    message.textContent = '';
    cartLink.hidden = true;
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : card.dataset.errorMessage);
      message.textContent = card.dataset.addedMessage + ' ';
      cartLink.hidden = false;
      try {
        const cartResponse = await fetch(card.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (cartResponse.ok) window.dispatchEvent(new CustomEvent('cartcount:update', { detail: await cartResponse.json() }));
      } catch (_) {}
    } catch (error) {
      message.textContent = (error instanceof TypeError ? card.dataset.errorMessage : error.message || card.dataset.errorMessage) + ' ';
      cartLink.hidden = false;
    } finally {
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-fruits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initEducatodoFruits(root) {
      if (!root || root.dataset.fruitsReady === 'true') return;
      root.dataset.fruitsReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-fruit-card]'));
      const languageButtons = Array.from(root.querySelectorAll('[data-language-button]'));
      const count = root.querySelector('[data-progress-count]');
      const bar = root.querySelector('[data-progress-bar]');
      const progress = root.querySelector('[data-progress-wrap]');
      const error = root.querySelector('[data-audio-error]');
      const gameStart = root.querySelector('[data-game-start]');
      const gamePlay = root.querySelector('[data-game-play]');
      const gameFinish = root.querySelector('[data-game-finish]');
      const gameStartButton = root.querySelector('[data-game-start-button]');
      const gameRestart = root.querySelector('[data-game-restart]');
      const gameReplay = root.querySelector('[data-game-replay]');
      const gameNext = root.querySelector('[data-game-next]');
      const gameOptions = root.querySelector('[data-game-options]');
      const gameRound = root.querySelector('[data-game-round]');
      const gameScore = root.querySelector('[data-game-score]');
      const gameLanguage = root.querySelector('[data-game-language]');
      const gameFeedback = root.querySelector('[data-game-feedback]');
      const gameFinalScore = root.querySelector('[data-game-final-score]');

      const fruitData = cards.map((card) => ({
        card,
        slug: card.dataset.slug,
        emoji: card.dataset.emoji,
        esName: card.dataset.esName,
        frName: card.dataset.frName,
        enName: card.dataset.enName,
        frAudio: card.dataset.audioFr,
        enAudio: card.dataset.audioEn,
        esAudio: card.dataset.audioEs
      }));

      const copy = {
        fr: {
          level: 'Français · Débutant',
          titleMain: 'Les fruits',
          titleAccent: 'en francés',
          intro: 'Toca el botón de cada fruta, escucha su pronunciación en francés y repítela en voz alta.',
          gameIntro: 'Escucha una palabra en francés y toca la fruta correcta.',
          eyebrow: 'Vocabulario en francés',
          footer: 'Pronunciación francesa · Nivel inicial',
          gameLanguage: 'Francés',
          startLabel: 'Comenzar en francés'
        },
        en: {
          level: 'English · Beginner',
          titleMain: 'Fruits',
          titleAccent: 'in English',
          intro: 'Toca el botón de cada fruta, escucha su pronunciación en inglés y repítela en voz alta.',
          gameIntro: 'Escucha una palabra en inglés y toca la fruta correcta.',
          eyebrow: 'Vocabulario en inglés',
          footer: 'Pronunciación inglesa · Nivel inicial',
          gameLanguage: 'Inglés',
          startLabel: 'Comenzar en inglés'
        },
        es: {
          level: 'Español de México · Inicial',
          titleMain: 'Las frutas',
          titleAccent: 'en español',
          intro: 'Toca el botón de cada fruta, escucha su pronunciación en español de México y repítela en voz alta.',
          gameIntro: 'Escucha una palabra en español de México y toca la fruta correcta.',
          eyebrow: 'Vocabulario en español',
          footer: 'Pronunciación mexicana · Nivel inicial',
          gameLanguage: 'Español',
          startLabel: 'Comenzar en español'
        }
      };

      const heard = { fr: new Set(), en: new Set(), es: new Set() };
      const quiz = { sequence: [], index: 0, score: 0, target: null, locked: false };
      let language = 'fr';
      let player = null;
      let activeCard = null;

      function nameFor(fruit) {
        return { fr: fruit.frName, en: fruit.enName, es: fruit.esName }[language];
      }

      function audioFor(fruit) {
        return { fr: fruit.frAudio, en: fruit.enAudio, es: fruit.esAudio }[language];
      }

      function setPlaying(card, playing) {
        card.classList.toggle('is-playing', playing);
        card.querySelectorAll('[data-play-fruit]').forEach((button) => {
          button.setAttribute('aria-pressed', playing ? 'true' : 'false');
        });
      }

      function clearPlaying() {
        if (activeCard) setPlaying(activeCard, false);
        activeCard = null;
      }

      function stopAudio() {
        if (player) {
          player.pause();
          player = null;
        }
        clearPlaying();
      }

      function updateProgress() {
        const total = cards.length;
        const value = heard[language].size;
        count.textContent = `${value}/${total}`;
        bar.style.width = `${total ? (value / total) * 100 : 0}%`;
        progress.setAttribute('aria-label', `${value} de ${total} frutas escuchadas`);
      }

      function showError() {
        error.hidden = false;
        clearPlaying();
      }

      function playAudio(source, options = {}) {
        stopAudio();
        error.hidden = true;

        player = new Audio(source);
        player.preload = 'auto';
        if (options.card) {
          activeCard = options.card;
          setPlaying(options.card, true);
        }

        player.addEventListener('ended', () => {
          clearPlaying();
          if (options.onEnded) options.onEnded();
        }, { once: true });
        player.addEventListener('error', showError, { once: true });
        player.play().then(() => {
          if (options.onStarted) options.onStarted();
        }).catch(showError);
      }

      function playFruit(card) {
        const fruit = fruitData.find((item) => item.card === card);
        if (!fruit) return;
        playAudio(audioFor(fruit), {
          card,
          onStarted: () => {
            heard[language].add(fruit.slug);
            card.classList.add('is-heard');
            updateProgress();
          }
        });
      }

      function shuffle(items) {
        const result = items.slice();
        for (let index = result.length - 1; index > 0; index -= 1) {
          const swapIndex = Math.floor(Math.random() * (index + 1));
          [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
        }
        return result;
      }

      function resetGame() {
        stopAudio();
        quiz.sequence = [];
        quiz.index = 0;
        quiz.score = 0;
        quiz.target = null;
        quiz.locked = false;
        gameStart.hidden = false;
        gamePlay.hidden = true;
        gameFinish.hidden = true;
        gameOptions.innerHTML = '';
        gameFeedback.hidden = true;
        gameNext.hidden = true;
        gameStartButton.textContent = copy[language].startLabel;
      }

      function playQuizAudio() {
        if (!quiz.target) return;
        playAudio(audioFor(quiz.target), {
          onStarted: () => {
            heard[language].add(quiz.target.slug);
            quiz.target.card.classList.add('is-heard');
            updateProgress();
          }
        });
      }

      function chooseOption(fruit, button) {
        if (quiz.locked) return;
        quiz.locked = true;
        const isCorrect = fruit.slug === quiz.target.slug;
        if (isCorrect) quiz.score += 1;
        gameScore.textContent = String(quiz.score);

        Array.from(gameOptions.querySelectorAll('button')).forEach((option) => {
          option.disabled = true;
          if (option.dataset.slug === quiz.target.slug) option.classList.add('is-correct');
        });
        if (!isCorrect) button.classList.add('is-wrong');

        gameFeedback.textContent = isCorrect
          ? `¡Correcto! ${nameFor(quiz.target)}`
          : `La respuesta era ${nameFor(quiz.target)}.`;
        gameFeedback.hidden = false;
        gameNext.textContent = quiz.index === quiz.sequence.length - 1 ? 'Ver resultado' : 'Siguiente';
        gameNext.hidden = false;
      }

      function renderRound() {
        quiz.target = quiz.sequence[quiz.index];
        quiz.locked = false;
        gameRound.textContent = `${quiz.index + 1}/${quiz.sequence.length}`;
        gameScore.textContent = String(quiz.score);
        gameFeedback.hidden = true;
        gameNext.hidden = true;
        gameOptions.innerHTML = '';

        const alternatives = shuffle(fruitData.filter((fruit) => fruit.slug !== quiz.target.slug)).slice(0, 2);
        shuffle([quiz.target, ...alternatives]).forEach((fruit) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'etf-option';
          button.dataset.slug = fruit.slug;
          button.setAttribute('aria-label', fruit.esName);
          button.innerHTML = `<span aria-hidden="true">${fruit.emoji}</span>${fruit.esName}`;
          button.addEventListener('click', () => chooseOption(fruit, button));
          gameOptions.appendChild(button);
        });

        playQuizAudio();
      }

      function startGame() {
        stopAudio();
        quiz.sequence = shuffle(fruitData).slice(0, 5);
        quiz.index = 0;
        quiz.score = 0;
        gameStart.hidden = true;
        gameFinish.hidden = true;
        gamePlay.hidden = false;
        renderRound();
      }

      function advanceGame() {
        quiz.index += 1;
        if (quiz.index >= quiz.sequence.length) {
          stopAudio();
          gamePlay.hidden = true;
          gameFinish.hidden = false;
          gameFinalScore.textContent = `${quiz.score}/${quiz.sequence.length}`;
          return;
        }
        renderRound();
      }

      function renderLanguage() {
        stopAudio();
        root.dataset.language = language;
        languageButtons.forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.languageButton === language ? 'true' : 'false');
        });
        root.querySelectorAll('[data-copy]').forEach((element) => {
          const key = element.dataset.copy;
          if (copy[language][key]) element.textContent = copy[language][key];
        });
        gameLanguage.textContent = copy[language].gameLanguage;
        cards.forEach((card) => {
          const fruit = fruitData.find((item) => item.card === card);
          const name = nameFor(fruit);
          card.querySelector('[data-fruit-name]').textContent = name;
          card.querySelector('.etf-card-copy p').textContent = language === 'es' ? 'Español de México' : fruit.esName;
          card.classList.toggle('is-heard', heard[language].has(fruit.slug));
          card.querySelectorAll('[data-play-fruit]').forEach((button) => {
            button.setAttribute('aria-label', `Escuchar la pronunciación de ${name}`);
          });
        });
        updateProgress();
        resetGame();
      }

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-play-fruit]');
        if (!button || !root.contains(button)) return;
        const card = button.closest('[data-fruit-card]');
        if (card) playFruit(card);
      });

      languageButtons.forEach((button) => {
        button.addEventListener('click', () => {
          language = button.dataset.languageButton;
          renderLanguage();
        });
      });
      gameStartButton.addEventListener('click', startGame);
      gameRestart.addEventListener('click', startGame);
      gameReplay.addEventListener('click', playQuizAudio);
      gameNext.addEventListener('click', advanceGame);

      renderLanguage();
    }

    document.querySelectorAll('[data-educatodo-fruits]').forEach(initEducatodoFruits);
    document.addEventListener('shopify:section:load', (event) => {
      initEducatodoFruits(event.target.querySelector('[data-educatodo-fruits]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-loteria"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffle = (items) => {
      const copy = [...items];
      for (let index = copy.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [copy[index], copy[randomIndex]] = [copy[randomIndex], copy[index]];
      }
      return copy;
    };

    const initialize = (root) => {
      if (!root || root.dataset.etlReady === 'true') return;
      root.dataset.etlReady = 'true';
      const words = JSON.parse(root.querySelector('[data-etl-words]').textContent);
      const bySlug = new Map(words.map((word) => [word.slug, word]));
      const state = {
        player: null, active: null, audioError: null, heard: new Set(),
        category: 'Todas', query: '', level: 'intermedio',
        round: 0, score: 0, streak: 0, best: 0,
        word: null, options: [], wrong: new Set(), answered: false, finished: false
      };
      const cards = root.querySelector('[data-etl-cards]');
      const count = root.querySelector('[data-etl-count]');
      const drawn = root.querySelector('[data-etl-drawn]');
      const game = root.querySelector('[data-etl-game]');
      const scoreboard = root.querySelector('[data-etl-scoreboard]');
      const progressLabel = root.querySelector('[data-etl-progress-label]');
      const progressBar = root.querySelector('[data-etl-progress-bar]');

      const renderProgress = () => {
        progressLabel.textContent = `${state.heard.size}/${words.length}`;
        progressBar.style.width = `${(state.heard.size / words.length) * 100}%`;
      };

      const play = (word) => {
        if (state.player) state.player.pause();
        const audio = new Audio(word.audio);
        state.player = audio;
        state.active = word.slug;
        state.audioError = null;
        audio.addEventListener('ended', () => {
          state.active = null;
          renderCards();
          renderGame();
        });
        audio.addEventListener('error', () => {
          state.active = null;
          state.audioError = word.slug;
          renderCards();
          renderGame();
        });
        audio.play().then(() => {
          state.heard.add(word.slug);
          renderProgress();
          renderCards();
          renderGame();
        }).catch(() => {
          state.active = null;
          state.audioError = word.slug;
          renderCards();
          renderGame();
        });
      };

      const renderCards = () => {
        const search = state.query.trim().toLocaleLowerCase('es');
        const filtered = words.filter((word) => {
          const categoryMatches = state.category === 'Todas' || word.cat === state.category;
          const queryMatches = !search || word.en.toLocaleLowerCase('en').includes(search) || word.es.toLocaleLowerCase('es').includes(search);
          return categoryMatches && queryMatches;
        });
        count.textContent = `${filtered.length} ${filtered.length === 1 ? 'tarjeta' : 'tarjetas'}`;
        if (!filtered.length) {
          cards.innerHTML = '<div class="etl-empty"><div style="font-size:48px">🔎</div><h3>No encontramos esa palabra</h3><p>Prueba con otra búsqueda o categoría.</p></div>';
          return;
        }
        cards.innerHTML = filtered.map((word) => {
          const index = words.findIndex((item) => item.slug === word.slug) + 1;
          const heard = state.heard.has(word.slug);
          const playing = state.active === word.slug;
          const error = state.audioError === word.slug;
          return `
            <button type="button" class="etl-card ${playing ? 'is-playing' : ''}" data-etl-card="${word.slug}" data-cat="${word.cat}" aria-label="Escuchar ${word.en}, ${word.es}">
              <span class="etl-card-visual">
                <span class="etl-card-number">#${String(index).padStart(2, '0')}</span>
                ${heard ? '<span class="etl-card-check" aria-label="Palabra escuchada">✓</span>' : ''}
                <span class="etl-card-emoji" aria-hidden="true">${word.emoji}</span>
                <span class="etl-card-play">${playing ? '♪' : '▶'}</span>
              </span>
              <span class="etl-card-copy">
                <b>${word.en}</b>
                <small>${word.es} · ${word.cat}</small>
                ${error ? '<small style="color:#b42318">No pudimos reproducir el audio.</small>' : ''}
              </span>
            </button>`;
        }).join('');
      };

      const renderLevels = () => {
        root.querySelectorAll('[data-etl-level]').forEach((button) => {
          const active = button.dataset.etlLevel === state.level;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      const renderScoreboard = () => {
        const active = state.round > 0 && !state.finished;
        scoreboard.hidden = !active;
        if (!active) return;
        scoreboard.innerHTML = `
          <div><small>Reto</small><b>${state.round}/10</b></div>
          <div><small>Puntos</small><b>${state.score}</b></div>
          <div><small>Racha</small><b>🔥 ${state.streak}</b></div>`;
      };

      const renderGame = () => {
        renderLevels();
        renderScoreboard();
        if (state.finished) {
          const icon = state.score >= 8 ? '🏆' : state.score >= 5 ? '⭐' : '💪';
          const message = state.score >= 8
            ? '¡Excelente oído! Reconoces muy bien el vocabulario.'
            : state.score >= 5
              ? '¡Buen trabajo! Repite la partida para superar tu puntuación.'
              : 'Cada intento entrena tu oído. Escucha las tarjetas y vuelve a intentarlo.';
          game.innerHTML = `
            <div class="etl-game-result">
              <div>
                <div class="etl-trophy">${icon}</div>
                <small>Partida terminada</small>
                <h3>${state.score}/10</h3>
                <p>Tu mejor racha fue de ${state.best} ${state.best === 1 ? 'acierto' : 'aciertos'}.</p>
                <p>${message}</p>
                <button type="button" data-etl-action="start">↻ Jugar otra vez</button>
              </div>
            </div>`;
          return;
        }
        if (!state.word) {
          game.innerHTML = `
            <div class="etl-game-welcome">
              <div>
                <span class="etl-headphones" aria-hidden="true">🎧</span>
                <h3>¿Puedes reconocer la palabra?</h3>
                <p>Escucharás una palabra y tendrás cuatro opciones. Cada acierto al primer intento vale un punto.</p>
                <button type="button" class="etl-primary" data-etl-action="start">▶ Comenzar partida</button>
              </div>
            </div>`;
          return;
        }
        const choices = state.options.map((option, index) => {
          const correct = state.answered && option.slug === state.word.slug;
          const wrong = state.wrong.has(option.slug);
          const label = state.level === 'avanzado' ? option.en : option.es;
          const visual = state.level === 'avanzado'
            ? `<span class="etl-choice-label">${option.en}</span>`
            : `<span class="etl-choice-emoji" aria-hidden="true">${option.emoji}</span>${state.level === 'principiante' ? `<span class="etl-choice-label">${option.es}</span>` : ''}`;
          return `
            <button type="button" class="etl-choice ${correct ? 'is-correct' : ''} ${wrong ? 'is-wrong' : ''}" data-etl-choice="${option.slug}" ${state.answered || wrong ? 'disabled' : ''} aria-label="Opción ${index + 1}: ${label}">
              ${visual}
            </button>`;
        }).join('');
        let feedback = '<p style="text-align:center;color:#778491;font-weight:700">Puedes repetir el audio todas las veces que necesites.</p>';
        if (state.answered) {
          feedback = `
            <div class="etl-feedback-box is-good">
              <span>🎉 ¡Correcto! <b>${state.word.en}</b> significa <b>${state.word.es}</b>.</span>
              <button type="button" data-etl-action="next">${state.round === 10 ? 'Ver resultado' : 'Siguiente reto →'}</button>
            </div>`;
        } else if (state.wrong.size) {
          feedback = '<div class="etl-feedback-box is-try">Casi. Escucha otra vez y prueba con otra opción.</div>';
        }
        game.innerHTML = `
          <div class="etl-challenge">
            <div class="etl-listen-bar">
              <div><small>Reto ${state.round}</small><h3>Escucha y selecciona la respuesta</h3></div>
              <button type="button" data-etl-action="replay">${state.active === state.word.slug ? '♪ Reproduciendo…' : '🔊 Escuchar otra vez'}</button>
            </div>
            ${state.audioError === state.word.slug ? '<p class="etl-audio-error" role="alert">No pudimos reproducir el audio. Presiona “Escuchar otra vez”.</p>' : ''}
            <div class="etl-choices">${choices}</div>
            <div class="etl-feedback" aria-live="polite">${feedback}</div>
          </div>`;
      };

      const createChallenge = (previousSlug) => {
        const candidates = words.filter((word) => word.slug !== previousSlug);
        const correct = candidates[Math.floor(Math.random() * candidates.length)];
        const sameCategory = shuffle(words.filter((word) => word.slug !== correct.slug && word.cat === correct.cat));
        const others = shuffle(words.filter((word) => word.slug !== correct.slug && word.cat !== correct.cat));
        return { correct, options: shuffle([correct, ...[...sameCategory, ...others].slice(0, 3)]) };
      };
      const launchRound = (previousSlug) => {
        const challenge = createChallenge(previousSlug);
        state.word = challenge.correct;
        state.options = challenge.options;
        state.wrong = new Set();
        state.answered = false;
        state.finished = false;
        renderGame();
        play(challenge.correct);
      };
      const startGame = () => {
        state.round = 1;
        state.score = 0;
        state.streak = 0;
        state.best = 0;
        launchRound();
      };

      root.addEventListener('input', (event) => {
        if (!event.target.matches('[data-etl-search]')) return;
        state.query = event.target.value;
        renderCards();
      });
      root.addEventListener('click', (event) => {
        const category = event.target.closest('[data-etl-category]');
        if (category) {
          state.category = category.dataset.etlCategory;
          root.querySelectorAll('[data-etl-category]').forEach((button) => button.classList.toggle('is-active', button === category));
          renderCards();
          return;
        }
        const card = event.target.closest('[data-etl-card]');
        if (card) {
          play(bySlug.get(card.dataset.etlCard));
          return;
        }
        const level = event.target.closest('[data-etl-level]');
        if (level) {
          state.level = level.dataset.etlLevel;
          state.round = 0;
          state.score = 0;
          state.streak = 0;
          state.best = 0;
          state.word = null;
          state.options = [];
          state.wrong = new Set();
          state.answered = false;
          state.finished = false;
          renderGame();
          return;
        }
        const choice = event.target.closest('[data-etl-choice]');
        if (choice && state.word && !state.answered) {
          const option = bySlug.get(choice.dataset.etlChoice);
          if (option.slug === state.word.slug) {
            state.answered = true;
            if (state.wrong.size === 0) {
              state.score += 1;
              state.streak += 1;
              state.best = Math.max(state.best, state.streak);
            }
          } else {
            state.wrong.add(option.slug);
            state.streak = 0;
          }
          renderGame();
          return;
        }
        const action = event.target.closest('[data-etl-action]');
        if (!action) return;
        const name = action.dataset.etlAction;
        if (name === 'random') {
          const word = words[Math.floor(Math.random() * words.length)];
          drawn.hidden = false;
          drawn.innerHTML = `
            <div class="etl-drawn-inner">
              <div class="etl-drawn-word">
                <span class="etl-drawn-emoji">${word.emoji}</span>
                <div><small>Carta al azar</small><h3>${word.en} <span>· ${word.es}</span></h3></div>
              </div>
              <button type="button" class="etl-btn etl-btn-yellow" data-etl-random-replay="${word.slug}">🔊 Repetir palabra</button>
            </div>`;
          play(word);
          return;
        }
        if (name === 'start') startGame();
        if (name === 'replay' && state.word) play(state.word);
        if (name === 'next') {
          if (state.round >= 10) {
            state.finished = true;
            state.word = null;
            state.options = [];
            renderGame();
          } else {
            const previousSlug = state.word && state.word.slug;
            state.round += 1;
            launchRound(previousSlug);
          }
        }
      });
      drawn.addEventListener('click', (event) => {
        const button = event.target.closest('[data-etl-random-replay]');
        if (button) play(bySlug.get(button.dataset.etlRandomReplay));
      });
      renderProgress();
      renderCards();
      renderGame();
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-etl-root]').forEach(initialize);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["educatodo-play"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffle=(items)=>{const copy=[...items];for(let i=copy.length-1;i>0;i-=1){const j=Math.floor(Math.random()*(i+1));[copy[i],copy[j]]=[copy[j],copy[i]];}return copy;};
    const escapeHtml=(value)=>String(value??'').replace(/[&<>"']/g,(character)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character]));
    const init=(root)=>{
      if(!root||root.dataset.etpReady==='true')return;const configNode=root.querySelector('[data-etp-config]');if(!configNode)return;root.dataset.etpReady='true';
      const config=JSON.parse(configNode.textContent);const items=config.items;const byId=new Map(items.map((item)=>[item.id,item]));const storageKey=`educatodo-play:${config.slug}:v${config.version}`;
      const saved=(()=>{try{return JSON.parse(localStorage.getItem(storageKey)||'{}');}catch{return {};}})();
      const state={mode:'learn',player:null,active:null,error:null,heard:new Set(Array.isArray(saved.heard)?saved.heard:[]),best:Number(saved.best||0),query:'',category:'Todos',quiz:[],round:0,score:0,answer:null,wrong:null,options:null,sequence:false,sequenceQueue:[],sequenceIndex:0,stage:null,teams:{a:0,b:0},toastTimer:null};
      const grid=root.querySelector('[data-etp-grid]');const game=root.querySelector('[data-etp-game]');const stage=root.querySelector('[data-etp-stage]');const live=root.querySelector('[data-etp-live]');const scoreNode=root.querySelector('[data-etp-score]');
      const colors=['#eee8ff','#fff0ad','#dff4ff','#e5f5d6','#ffe5dc','#dff5ef'];
      const save=()=>{try{localStorage.setItem(storageKey,JSON.stringify({heard:[...state.heard],best:state.best}));}catch{}};
      const toast=(message)=>{live.textContent=message;live.classList.add('is-visible');clearTimeout(state.toastTimer);state.toastTimer=setTimeout(()=>live.classList.remove('is-visible'),2200);};
      const visual=(item,className)=>item.image?`<img src="${escapeHtml(item.image)}" alt="" loading="lazy">`:`<span class="${className}">${escapeHtml(item.emoji)}</span>`;
      const renderProgress=()=>{const count=state.heard.size;root.querySelector('[data-etp-progress-label]').textContent=`${count}/${items.length}`;root.querySelector('[data-etp-progress-bar]').style.width=`${items.length?count/items.length*100:0}%`;};
      const play=(item,onEnded)=>{if(state.player)state.player.pause();if(!item?.audio){state.error=item?.id;toast('Este elemento aún no tiene audio.');renderAll();return;}const audio=new Audio(item.audio);state.player=audio;state.active=item.id;state.error=null;const finish=()=>{state.active=null;renderLearn();renderPractice();renderStage();if(onEnded)onEnded();};audio.addEventListener('ended',finish,{once:true});audio.addEventListener('error',()=>{state.error=item.id;state.sequence=false;finish();toast('No pudimos reproducir este audio.');},{once:true});audio.play().then(()=>{state.heard.add(item.id);save();renderProgress();renderLearn();}).catch(()=>{state.error=item.id;state.active=null;state.sequence=false;renderAll();toast('Toca nuevamente para reproducir.');});};
      const switchMode=(mode)=>{if(!root.querySelector(`[data-etp-panel="${mode}"]`))return;state.mode=mode;root.querySelectorAll('[data-etp-mode]').forEach((button)=>button.classList.toggle('is-active',button.dataset.etpMode===mode));root.querySelectorAll('[data-etp-panel]').forEach((panel)=>{panel.hidden=panel.dataset.etpPanel!==mode;});root.querySelector('.etp-app').scrollIntoView({behavior:'smooth',block:'start'});if(mode==='teacher')renderStage();};
      const renderCategories=()=>{const categories=['Todos',...new Set(items.map((item)=>item.category).filter(Boolean))];root.querySelector('[data-etp-categories]').innerHTML=categories.map((category)=>`<button type="button" class="${category===state.category?'is-active':''}" data-etp-category="${escapeHtml(category)}">${escapeHtml(category)}</button>`).join('');};
      const renderLearn=()=>{const query=state.query.trim().toLocaleLowerCase('es');const filtered=items.filter((item)=>(state.category==='Todos'||item.category===state.category)&&(!query||item.primary.toLocaleLowerCase('es').includes(query)||item.secondary.toLocaleLowerCase('es').includes(query)));root.querySelector('[data-etp-count]').textContent=`${filtered.length} ${filtered.length===1?'elemento':'elementos'}`;grid.innerHTML=filtered.length?filtered.map((item)=>{const index=items.indexOf(item);return `<button type="button" class="etp-card${state.active===item.id?' is-playing':''}" style="--card-bg:${colors[index%colors.length]}" data-etp-item="${escapeHtml(item.id)}"><span class="etp-card-visual">${state.heard.has(item.id)?'<span class="etp-card-check">✓</span>':''}${visual(item,'etp-card-emoji')}<span class="etp-card-play">▶</span></span><span class="etp-card-copy"><b>${escapeHtml(item.primary)}</b><small>${escapeHtml(item.secondary)}</small></span></button>`;}).join(''):'<div class="etp-empty"><div style="font-size:48px">🔎</div><h3>No encontramos coincidencias</h3><p>Prueba otra búsqueda o categoría.</p></div>';};
      const renderScore=()=>{scoreNode.hidden=!state.quiz.length;scoreNode.innerHTML=`Reto <span>${Math.min(state.round+1,config.rounds)}/${config.rounds}</span> · Aciertos <span>${state.score}</span> · Récord <span>${state.best}</span>`;};
      const startQuiz=()=>{const rounds=Math.min(Math.max(Number(config.rounds)||10,1),items.length);state.quiz=shuffle(items.filter((item)=>item.audio)).slice(0,rounds);state.round=0;state.score=0;state.answer=null;state.wrong=null;state.options=null;state.error=null;renderPractice();if(state.quiz[0])play(state.quiz[0]);};
      const renderPractice=()=>{renderScore();if(!state.quiz.length){game.innerHTML=`<div class="etp-welcome"><div><span class="etp-welcome-icon">🎧</span><h3>Entrena lo que aprendiste</h3><p>Escucha un elemento y elige la respuesta correcta. Tu mejor resultado se guarda en este dispositivo.</p><button type="button" class="etp-primary-button" data-etp-start>Comenzar ${Math.min(config.rounds,items.length)} retos</button></div></div>`;return;}if(state.round>=state.quiz.length){state.best=Math.max(state.best,state.score);save();renderScore();game.innerHTML=`<div class="etp-result"><div><div style="font-size:70px">🏆</div><h3>${state.score}/${state.quiz.length}</h3><p>${state.score>=Math.ceil(state.quiz.length*.8)?'¡Excelente resultado!':'¡Buen trabajo! Explora las tarjetas y vuelve a intentarlo.'}</p><button type="button" class="etp-primary-button" data-etp-start>Jugar otra vez</button></div></div>`;return;}const target=state.quiz[state.round];if(!state.options)state.options=shuffle([target,...shuffle(items.filter((item)=>item.id!==target.id)).slice(0,Math.min(3,items.length-1))]);game.innerHTML=`<div class="etp-challenge"><div class="etp-listen"><div><small>Reto ${state.round+1} de ${state.quiz.length}</small><h3>${escapeHtml(config.quizPrompt)}</h3></div><button type="button" data-etp-replay>🔊 Repetir sonido</button></div>${state.error===target.id?'<p class="etp-error">No pudimos reproducir este audio. Intenta nuevamente.</p>':''}<div class="etp-choices">${state.options.map((item)=>`<button type="button" class="etp-choice${state.answer===item.id?' is-correct':''}${state.wrong===item.id?' is-wrong':''}" data-etp-choice="${escapeHtml(item.id)}" ${state.answer?'disabled':''}><span class="etp-choice-visual">${visual(item,'')}</span><b>${escapeHtml(item.primary)}</b><small>${escapeHtml(item.secondary)}</small></button>`).join('')}</div><div class="etp-feedback">${state.answer?`<div class="good"><span>✓ ¡Correcto! ${escapeHtml(target.primary)}.</span><button type="button" data-etp-next>${state.round===state.quiz.length-1?'Ver resultado':'Siguiente reto'} →</button></div>`:state.wrong?'<div class="try"><span>Escucha otra vez e inténtalo de nuevo.</span></div>':''}</div></div>`;};
      const renderStage=()=>{if(!stage)return;if(!state.stage){stage.innerHTML='<div class="etp-stage-empty"><span>🎲</span><h3>Selecciona un elemento al azar</h3></div>';return;}const item=state.stage;stage.innerHTML=`<div class="etp-stage-card"><div class="etp-stage-visual">${visual(item,'')}</div><h3>${escapeHtml(item.primary)}</h3><p>${escapeHtml(item.secondary)}</p><button type="button" data-etp-stage-play>🔊 Reproducir sonido</button></div>`;};
      const renderTeams=()=>{root.querySelectorAll('[data-etp-team-score]').forEach((node)=>{node.textContent=state.teams[node.dataset.etpTeamScore];});};
      const stopSequence=()=>{state.sequence=false;const button=root.querySelector('[data-etp-sequence]');if(button)button.textContent='▶ Secuencia automática';if(state.player)state.player.pause();state.active=null;};
      const nextSequence=()=>{if(!state.sequence)return;if(state.sequenceIndex>=state.sequenceQueue.length){stopSequence();toast('Secuencia completada.');return;}state.stage=state.sequenceQueue[state.sequenceIndex++];renderStage();play(state.stage,nextSequence);};
      const renderAll=()=>{renderProgress();renderLearn();renderPractice();renderStage();renderTeams();};
      root.addEventListener('click',(event)=>{const mode=event.target.closest('[data-etp-mode]');if(mode){switchMode(mode.dataset.etpMode);return;}const open=event.target.closest('[data-etp-open]');if(open){switchMode(open.dataset.etpOpen);return;}const card=event.target.closest('[data-etp-item]');if(card){play(byId.get(card.dataset.etpItem));return;}const category=event.target.closest('[data-etp-category]');if(category){state.category=category.dataset.etpCategory;renderCategories();renderLearn();return;}if(event.target.closest('[data-etp-start]')){startQuiz();return;}if(event.target.closest('[data-etp-replay]')){play(state.quiz[state.round]);return;}const choice=event.target.closest('[data-etp-choice]');if(choice&&!state.answer){const target=state.quiz[state.round];if(choice.dataset.etpChoice===target.id){state.answer=target.id;state.score+=1;}else state.wrong=choice.dataset.etpChoice;renderPractice();return;}if(event.target.closest('[data-etp-next]')){state.round+=1;state.answer=null;state.wrong=null;state.options=null;state.error=null;renderPractice();if(state.round<state.quiz.length)play(state.quiz[state.round]);return;}if(event.target.closest('[data-etp-random]')){stopSequence();state.stage=items[Math.floor(Math.random()*items.length)];renderStage();play(state.stage);return;}if(event.target.closest('[data-etp-sequence]')){if(state.sequence){stopSequence();return;}state.sequence=true;state.sequenceQueue=shuffle(items.filter((item)=>item.audio));state.sequenceIndex=0;event.target.closest('[data-etp-sequence]').textContent='■ Detener secuencia';nextSequence();return;}if(event.target.closest('[data-etp-stage-play]')){play(state.stage);return;}const teamAction=event.target.closest('[data-etp-team-action]');if(teamAction){const [team,delta]=teamAction.dataset.etpTeamAction.split(':');state.teams[team]=Math.max(0,state.teams[team]+Number(delta));renderTeams();return;}if(event.target.closest('[data-etp-reset-score]')){state.teams={a:0,b:0};renderTeams();return;}if(event.target.closest('[data-etp-fullscreen]')){if(!document.fullscreenElement)root.requestFullscreen?.();else document.exitFullscreen?.();}});
      root.querySelector('[data-etp-search]').addEventListener('input',(event)=>{state.query=event.target.value;renderLearn();});
      renderCategories();renderAll();
    };
    const initializeAll=()=>document.querySelectorAll('[data-etp-root]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeAll);else initializeAll();document.addEventListener('shopify:section:load',(event)=>init(event.target.querySelector('[data-etp-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
